<div class="dialog-header">
  <div class="header-title">
    <span class="header-span" *ngIf="!isMobile">{{dialogHeader}}</span>
    <span class="header-span" *ngIf="isMobile">Send Email</span>
  </div>

  <div class="buttons-block" *ngIf="!activityQuote.awardSent">
    <button class="header-button drawing-button" mat-button (click)="openLastDrawing()" [disabled]="submitLoading"
            [ngClass]="{'disabled-button': submitLoading}">
      <span>Drawing</span>
    </button>

    <button class="header-button send-button" mat-button (click)="sendQuote()" [disabled]="submitLoading"
            [ngClass]="{'disabled-button': submitLoading}" *ngIf="!activityQuote.sentDate && !this.activityQuote.price">
      <span *ngIf="!submitLoading">Send Quote Request</span>
      <lib-mini-progress-spinner *ngIf="submitLoading"></lib-mini-progress-spinner>
    </button>

    <button class="header-button send-button" mat-button (click)="sendAward()" [disabled]="submitLoading"
            [ngClass]="{'disabled-button': submitLoading}" *ngIf="activityQuote.sentDate || this.activityQuote.price">
      <span *ngIf="!submitLoading">Award Project</span>
      <lib-mini-progress-spinner *ngIf="submitLoading"></lib-mini-progress-spinner>
    </button>
  </div>
  <div class="buttons-block" *ngIf="activityQuote.awardSent">
    <button class="header-button cancel-button" mat-button (click)="cancelQuote()">
      Cancel Award
    </button>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="info-block" *ngIf="!showLoadingSpinner && activityQuote.awardSent">
		<span class="info-msg">Award Sent By: {{activityQuote.awardSentBy?.name}}
      {{activityQuote.awardSent | date: 'MMM dd h:mm a'}}</span>
  </div>

  <div class="info-block" *ngIf="!showLoadingSpinner && activityQuote.sentDate && !activityQuote.awardSent">
		<span class="info-msg">Quote Sent By: {{activityQuote.sentBy?.name}}
      {{activityQuote.sentDate | date: 'MMM dd h:mm a'}}</span>
  </div>

  <div class="text-block" *ngIf="!showLoadingSpinner">
		<textarea matInput [required]="true" [(ngModel)]="textAreaMessage" name="message"
              [disabled]="!!activityQuote.awardSent || submitLoading"
              [ngClass]="{'can-be-edited': !activityQuote.awardSent}"></textarea>
  </div>

  <div class="text-block loading-block" *ngIf="showLoadingSpinner">
    <lib-progress-spinner></lib-progress-spinner>
  </div>
</div>

<p-confirmDialog appendTo="body" icon="pi pi-ban" styleClass="item-panel">
</p-confirmDialog>
